import {Network} from "../../../network/Network";
import {ProductType} from "../../../models/product/ProductType";
import {HttpStatus} from "../../../network/status/HttpStatus";
import {INetworkComponent} from "../../../network/types/INetworkComponent";
import {ICommunityReportIncoming} from "../../../models/community/report/ICommunityReportIncoming";
import {ICommunityReportOverviewIncoming} from "../../../models/community/report/ICommunityReportOverviewIncoming";
import {ICommunityReportGenerateOutgoing} from "../../../models/community/report/ICommunityReportGenerateOutgoing";
import {ICommunityReportShareIncoming} from "../../../models/community/report/ICommunityReportShareIncoming";

export class CommunityReportService {

    public static dispose(): void {
    }

    public static init(): void {
    }

    public static async list(communityId: string, component?: INetworkComponent): Promise<ICommunityReportOverviewIncoming[]> {
        let request = await Network.get(ProductType.COMMUNITY, `/community/report/list/${communityId}`, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async getById(reportId: string, component?: INetworkComponent): Promise<ICommunityReportIncoming> {
        let request = await Network.get(ProductType.COMMUNITY, `/community/report/${reportId}`, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async generate(data: ICommunityReportGenerateOutgoing, component?: INetworkComponent): Promise<ICommunityReportIncoming> {
        let request = await Network.postJson(ProductType.COMMUNITY, `/community/report/generate`, data, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async delete(reportId: string, component?: INetworkComponent): Promise<void> {
        await Network.delete(ProductType.COMMUNITY, `/community/report/${reportId}`, component);
    }

    public static async getShared(shareToken: string, reportId: string, component?: INetworkComponent): Promise<ICommunityReportShareIncoming> {
        let request = await Network.get(ProductType.COMMUNITY, `/community/share/${shareToken}/report/${reportId}`, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }
}
